export const CREATE_PROGRAM = `
  mutation createProgram($input: CreateProgramInput!, $tenant_id: Int!) {
    createProgram(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on Program {
        id
        name
        category_id
        region_id
        key_group
        budget
        include
        link
        active
        interior
        province_id
        monthly_fee
        signup
        humand_exclude
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
        pricings {
            id
            program_variant_id
            vistage_group_id
            monthly_fee
            signup
            budget
            expenses
            valid_to
            its
            uts
            dts
            created_by
            updated_by
            deleted_by
        }
      }

      ... on ResultError {
        message
      }
    }
  }
`;

export const UPDATE_PROGRAM = `
  mutation updateProgram($id: Int!, $input: UpdateProgramInput!, $tenant_id: Int!) {
    updateProgram(id: $id, input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Program {
        id
        name
        category_id
        region_id
        key_group
        budget
        include
        link
        active
        interior
        province_id
        monthly_fee
        signup
        humand_exclude
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
        pricings {
            id
            program_variant_id
            vistage_group_id
            monthly_fee
            signup
            budget
            expenses
            valid_to
            its
            uts
            dts
            created_by
            updated_by
            deleted_by
        }
        category {
          id
          name
        }
        region {
          id
          name
        }
      }

      ... on ResultError {
        message
      }
    }
  }
`;

export const DELETE_PROGRAM = `
  mutation deleteProgram($id: Int!, $tenant_id: Int!) {
    deleteProgram(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Program {
        id
      }
      ... on ResultError {
        message
      }
    }
  }
`;

export const CREATE_PROGRAM_PRICING = `
  mutation createProgramPricing($input: CreateProgramPricingInput!, $tenant_id: Int!) {
    createProgramPricing(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProgramPricing {
        id
        program_id
        program_variant_id
        vistage_group_id
        monthly_fee
        signup
        budget
        expenses
        valid_to
        is_active
      }
      ... on ResultError {
        message
      }
    }
  }
`;

export const UPDATE_PROGRAM_PRICES = `
  mutation updateProgramPrices($input: [UpdateProgramPricesInput!]!, $tenant_id: Int!) {
    updateProgramPrices(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProgramPricing {
        id
        program_id
        program_variant_id
        vistage_group_id
        monthly_fee
        signup
        budget
        expenses
        valid_to
        is_active
      }
      ... on ResultError {
        message
        status_code
        message_translation_key
      }
    }
  }
`;
